import { Cookies } from 'react-cookie';

import axiosInterceptor from '../interceptor/axiosClient';

import { ACCESS_TOKEN_COOKIE, COOKIE_OPTIONS } from './constants';
import { RegisterResponse, UserRegistrationData } from './types';

export const registration = async (registrationData: UserRegistrationData) => {
  const response = await axiosInterceptor.post<RegisterResponse>('/register/', registrationData, {});

  const cookies = new Cookies();
  cookies.set(ACCESS_TOKEN_COOKIE, `Token ${response.data.token}`, COOKIE_OPTIONS);

  return response;
};
